import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-files-table-data',
  templateUrl: './files-table-data.component.html',
  styleUrls: ['./files-table-data.component.scss']
})
export class FilesTableDataComponent implements OnInit {

    @Input() files: Array<File>;

    constructor() { }

    ngOnInit() {

    }

}



// WEBPACK FOOTER //
// /home/jacobo/proyectos/venta-extranet/src/app/files/components/files-table-data/files-table-data.component.ts